import { cn } from "@/lib/utils"

interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  children?: React.ReactNode
}

export function Panel({
  position = 'top-left',
  className,
  children,
  ...props
}: PanelProps) {
  return (
    <div
      className={cn(
        'fixed z-50',
        position === 'top-left' && 'top-4 left-4',
        position === 'top-right' && 'top-4 right-4',
        position === 'bottom-left' && 'bottom-4 left-4',
        position === 'bottom-right' && 'bottom-4 right-4',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
